const normalize = value => value.replace(/\s+/g, '-').toLowerCase();

export default normalize;



// WEBPACK FOOTER //
// ./src/services/normalize-string/index.js